<template>
	<div>
		<Header :logo="`${imgPath}/static/assets/img/brand/4/logo.png`" :width="2.8" />
		<div class="bannerWrap">
			<img class="bannerImg" :src="`${imgPath}/static/assets/img/brand/4/banner.jpg`" />
			<cloud />
		</div>
		<div class="brandWrap brand4" :class="{'zh-cn': lang=='zh-cn','en-us':lang == 'en-us'}">
			<div class="brandWrapModule" :class="{'zhw': lang=='zh-cn','letterSpace': lang == 'en-us'}">
			<p :class="{'field_0 item_center': lang=='zh-cn','field_1': lang == 'en-us'}" v-html="detail.field_1"></p>
			<p class="field_2" :class="{'item_center': lang=='zh-cn'}" :style="{ 'marginTop': lang=='zh-cn'? '0.7rem' : '0.66rem' }" v-html="detail.field_2"></p>
			</div>
			<p class="brandImg_style2" :style="{ 'marginTop': lang=='zh-cn'? '1.58rem' : '2.32rem' }"><img :src="detail.field_3" width="100%" /></p>
			<div :class="{'brandWrapModule3 zhw': lang=='zh-cn','brandWrapModule letterSpace': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '1.85rem' : '1.24rem' }">
				<p :class="{'field_0 item_center': lang=='zh-cn','field_1': lang == 'en-us'}" v-html="detail.field_4"></p>
				<p class="field_2" :class="{'item_center': lang=='zh-cn'}" :style="{ 'marginTop': lang=='zh-cn'? '0.44rem' : '0.67rem' }" v-html="detail.field_5"></p>
			</div>
			<div class="pressImgWrap" :style="{ 'marginTop': lang=='zh-cn'? '1.26rem' : '1.84rem' }">
				<img :src="detail.field_6" width="100%" />
				<img class="upImg" style="width:6.18rem" :src="detail.field_7" width="100%" />
			</div>
			<div :class="{'brandWrapModule3': lang=='zh-cn','brandWrapModule letterSpace': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '4.58rem' : '4.12rem' }">
				<p :class="{'field_0': lang=='zh-cn','field_1': lang == 'en-us'}" v-html="detail.field_8"></p>
				<p class="field_2" :style="{ 'marginTop': lang=='zh-cn'? '0.51rem' : '0.66rem' }" v-html="detail.field_9"></p>
			</div>
			<p class="brandImg_style4" :style="{ 'marginTop': lang=='zh-cn'? '2.09rem' : '1.17rem' }"><img :src="detail.field_10" width="100%" /></p>
			<div :class="{'brandWrapModule3': lang=='zh-cn','brandWrapModule letterSpace': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '1.39rem' : '1.17rem' }">
				<p :class="{'field_0': lang=='zh-cn','field_1': lang == 'en-us'}" v-html="detail.field_11"></p>
				<p class="field_2" :style="{ 'marginTop': lang=='zh-cn'? '0.66rem' : '0.57rem' }" v-html="detail.field_12"></p>
			</div>
			<p class="brandImg_style2" :style="{ 'marginTop': lang=='zh-cn'? '1.62rem' : '1.17rem' }"><img :src="detail.field_13" width="100%" /></p>
			<div class="brandWrapModule" :class="{'letterSpace': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '1.94rem' : '1.84rem' }">
				<p :class="{'field_0': lang=='zh-cn','field_1': lang == 'en-us'}" v-html="detail.field_14"></p>
				<p class="field_2" :style="{ 'marginTop': lang=='zh-cn'? '0.66rem' : '0.57rem' }" v-html="detail.field_15"></p>
			</div>
			<p class="brandImg_style1" :style="{ 'marginTop': lang=='zh-cn'? '1.58rem' : '1.33rem' }"><img :src="detail.field_16" width="100%" /></p>
			<a class="brandLinkWrap black" href="https://www.hlajeans.cn/index" target="_blank">
				<p class="brandLink1">{{ $t('shoplink') }}</p>
				<p class="brandLink2">www.hlajeans.cn/index</p>
				<img class="linkIcon" :src="`${imgPath}/static/assets/img/brand/linkImg1.png`" />
			</a>
			<top />
			<div class="cloudImg">
				<img :src="`${imgPath}/static/assets/img/cloud.png`" />
			</div>
			<bottom />
		</div>
	</div>
</template>
<script>
export default {
    data(){
		return{
			detail:{},
			lang: this.$route.query.lang || localStorage.getItem('language')||'zh-cn'
		}
	},
	async mounted() {
		let res = await this.$util.getBrandDetail(11)
		this.detail = res;
	},
	methods:{
	}
}
</script>

<style lang="scss" scoped>
	@import "../../assets/css/brandStyle.scss";
</style>


// WEBPACK FOOTER //
// src/views/brand/brand4.vue